import { useEffect, useRef } from "react";
import useWorkspaces from "./useWorkspaces";
import envConfig from "../../envConfig";

const useElectronWorkspace = () => {
  const { getActiveWorkspace } = useWorkspaces();
  const prevWorkspaceRef = useRef(null);
  const clearTimerRef = useRef(null);
  const lastSentRef = useRef(null);

  useEffect(() => {
    if (!window.electronAPI) return;

    const activeWorkspace = getActiveWorkspace();
    const currentId = activeWorkspace?.id;
    const currentToken = activeWorkspace?.workspaceToken;
    const currentKey = currentId ? `${currentId}:${currentToken ?? ""}` : null;

    if (prevWorkspaceRef.current !== currentKey) {
      prevWorkspaceRef.current = currentKey;

      if (activeWorkspace?.id && activeWorkspace?.workspaceToken) {
        // Context churn re-runs this effect with the same id+token after a
        // transient blip — don't re-send what the host already has.
        const last = lastSentRef.current;
        if (
          !last ||
          last.id !== activeWorkspace.id ||
          last.token !== activeWorkspace.workspaceToken
        ) {
          lastSentRef.current = {
            id: activeWorkspace.id,
            token: activeWorkspace.workspaceToken,
          };
          console.log(
            "[ElectronWorkspace] Setting active workspace:",
            activeWorkspace.id,
          );
          window.electronAPI.setActiveWorkspace({
            id: activeWorkspace.id,
            workspaceToken: activeWorkspace.workspaceToken,
            region: envConfig.REACT_APP_REGION,
          });
        }
      } else {
        // Workspace context churn can transiently resolve undefined during
        // interleaved renders. Killing the sidecar on a transient blip caused
        // the offline cycle, so only clear if it stays gone (real sign-out).
        if (clearTimerRef.current) clearTimeout(clearTimerRef.current);
        clearTimerRef.current = setTimeout(() => {
          if (!getActiveWorkspace()?.id) {
            console.log("[ElectronWorkspace] Clearing active workspace");
            window.electronAPI.clearActiveWorkspace();
          }
        }, 10000);
      }
    }
  }, [getActiveWorkspace()?.id, getActiveWorkspace()?.workspaceToken]);

  return null;
};

export default useElectronWorkspace;
